const gonderimDurumu = () => {

﻿
    const gonderimDurumuEnum = {
      "Gonderilecek" : 1,
      "Gonderildi" : 2,
      "Gonderilmeyecek(0 Tutarli)":3,
      "Gonderilmeyecek(MIS Entegrasyonu Yok)":4,
      "Gonderilmeyecek(Kullanici Karari)":5
    }

    return {gonderimDurumuEnum};
}

export default gonderimDurumu;